import apiClient from './apiClient';
import type {
    LegalDocument,
    CreateLegalDocumentDto,
    UpdateLegalDocumentDto,
} from '../types/types';

const legalDocumentsService = {
    getAll: async (): Promise<LegalDocument[]> => {
        const res = await apiClient.get<LegalDocument[]>('/documents', { params: { all: 1 } });
        return res.data;
    },

    create: async (dto: CreateLegalDocumentDto): Promise<LegalDocument> => {
        const res = await apiClient.post<LegalDocument>('/documents', dto);
        return res.data;
    },

    update: async (id: number, dto: UpdateLegalDocumentDto): Promise<LegalDocument> => {
        const res = await apiClient.put<LegalDocument>(`/documents/${id}`, dto);
        return res.data;
    },

    remove: async (id: number): Promise<{ message: string }> => {
        const res = await apiClient.delete<{ message: string }>(`/documents/${id}`);
        return res.data;
    },

    publish: async (id: number): Promise<LegalDocument> => {
        const res = await apiClient.post<LegalDocument>(`/documents/${id}/publish`);
        return res.data;
    },

    supersede: async (id: number): Promise<LegalDocument> => {
        const res = await apiClient.post<LegalDocument>(`/documents/${id}/supersede`);
        return res.data;
    },

    seed: async (): Promise<{ created: number }> => {
        const res = await apiClient.post<{ created: number }>('/documents/seed');
        return res.data;
    },

    uploadContent: async (id: number, locale: string, file: File): Promise<LegalDocument> => {
        const formData = new FormData();
        formData.append('locale', locale);
        formData.append('file', file);
        const res = await apiClient.post<LegalDocument>(`/documents/${id}/content`, formData, {
            headers: { 'Content-Type': undefined },
        });
        return res.data;
    },
};

export default legalDocumentsService;
